import {
  browserSupportsWebAuthn,
  browserSupportsWebAuthnAutofill,
  startAuthentication,
  startRegistration,
  WebAuthnError
} from '@simplewebauthn/browser';

import {
  type PasskeyAuthOptions,
  type PasskeyAuthResponse,
  PasskeyCancelledError,
  type PasskeyRegisterOptions,
  type PasskeyRegisterResponse
} from './passkeyHelper.types';

export async function isPasskeySupported(): Promise<boolean> {
  return browserSupportsWebAuthn();
}

export async function passkeyAutofillAvailable(): Promise<boolean> {
  return browserSupportsWebAuthnAutofill();
}

function normalizeError(error: unknown): never {
  // Treat these as a quiet no-op, not a failure:
  //  - NotAllowedError: user dismissed the OS passkey prompt.
  //  - AbortError: the ceremony was superseded — e.g. the background autofill
  //    request aborts when the user taps the explicit "Sign in with a passkey".
  const name =
    error instanceof WebAuthnError || error instanceof Error ? error.name : '';
  if (name === 'NotAllowedError' || name === 'AbortError') {
    throw new PasskeyCancelledError();
  }
  throw error;
}

export async function createPasskey(
  options: PasskeyRegisterOptions
): Promise<PasskeyRegisterResponse> {
  try {
    return await startRegistration({ optionsJSON: options });
  } catch (error) {
    normalizeError(error);
  }
}

export async function getPasskey(
  options: PasskeyAuthOptions,
  useBrowserAutofill = false
): Promise<PasskeyAuthResponse> {
  try {
    return await startAuthentication({
      optionsJSON: options,
      useBrowserAutofill
    });
  } catch (error) {
    normalizeError(error);
  }
}
